// packages
import pip from 'point-in-polygon-hao';

/**
 * @template {import('geojson').Geometry | null} G
 * @typedef {import('geojson').Feature<G>} Feature
 */

/**
 * @typedef {import('geojson').BBox} BBox
 * @typedef {import('geojson').MultiPolygon} MultiPolygon
 * @typedef {import('geojson').Polygon} Polygon
 * @typedef {import('geojson').Position} Position
 */

/**
 *
 * @param {[x: number, y: number]} point
 * @param {Feature<Polygon | MultiPolygon>} feature
 * @returns
 */
export default function pointInPolygon(point, feature) {
  const geometry = feature.geometry;
  const type = geometry.type;

  const coordinates =
    type === 'Polygon' ? [geometry.coordinates] : geometry.coordinates;

  for (let idx = 0; idx < coordinates.length; idx++) {
    const polygon = coordinates[idx];

    const polyResult = pip(point, polygon);

    if (polyResult || polyResult === 0) {
      return true;
    }
  }

  return false;
}

/**
 *
 * @param {Position} pt
 * @param {BBox} bbox
 * @returns
 */
function inBBox(pt, bbox) {
  return (
    bbox[0] <= pt[0] && bbox[1] <= pt[1] && bbox[2] >= pt[0] && bbox[3] >= pt[1]
  );
}
